"use client";

import { usePathname } from "next/navigation";
import { AdminNavbar } from "@/components/admin/AdminNavbar";

export default function AdminLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  
  // Don't show the navbar on the main admin login page, or on Command
  // Center - it's its own full-screen app shell (own topbar + sidebar,
  // matching the reference Command Center design 1:1), not a page inside
  // Fixr's regular admin chrome.
  const isLoginPage = pathname === "/admin";
  const isCommandCenter = pathname === "/admin/command-center";

  if (isLoginPage || isCommandCenter) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <AdminNavbar />
      <div className="relative">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[320px] pointer-events-none opacity-80">
          <div className="absolute top-[-140px] left-1/4 w-[50%] h-full bg-emerald-100 blur-[120px] rounded-full" />
        </div>
        
        <main className="relative">{children}</main>
      </div>
      
      {/* Global Admin Footer */}
      <footer className="border-t border-slate-200 bg-white py-8 mt-12">
        <div className="mx-auto max-w-7xl px-4 text-center">
          <p className="text-[10px] font-bold text-slate-500 uppercase tracking-[0.2em]">
            Fixer Enterprise Solution · internal use only · © 2024
          </p>
        </div>
      </footer>
    </div>
  );
}
